import React from "react";
import { connect } from "react-redux";
import { ReportInfoColumns } from "../../tableColumns/table-columns";
import { ReportInfoJson } from "../../DynamicFormsJson/Transaction/reportInfo";
import { getReportInfo1 } from "../../Slice/report.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";

class ReportTable extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { reportList, getReportInfo1 } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={ReportInfoJson.formPath1}
                    screenTitle={ReportInfoJson.screenTitle}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    showAddButton={true}
                    tableColumnsToFilter={ReportInfoJson.tableColumnsToFilter}
                    tableColumns={ReportInfoColumns}
                    tableData={reportList?.report}
                    getTableData={getReportInfo1}
                    apiBaseURL={ReportInfoJson.apiBaseURL}
                    baseIdColumn={ReportInfoJson.baseIdColumn}
                    showPegination={false}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    reportList: state.report,
});
const mapDispatchToProps = {
    getReportInfo1,
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportTable);
